export const USER_COLUMNS = [
  {
    key: "user_id",
    label: "ID",
    align: "text-left"
  },
  {
    key: "user_name",
    label: "유저명",
    align: "text-left",
    editType: "input"
  },
  {
    key: "phone",
    label: "연락처",
    align: "text-left",
    editType: "input"
  },
  {
    key: "scope_type",
    label: "소속 유형",
    align: "text-left",
    editType: "select",
    options: [
      { value: "only", label: "개별" },
      { value: "group", label: "그룹" }
    ],
    disabled: (item) => item.role === "ADMIN"
  },
  {
    key: "scope_code",
    label: "소속 코드",
    align: "text-left",
    editType: "input",
    disabled: (item) => item.role === "ADMIN"
  },
  {
    key: "scope_name",
    label: "소속",
    align: "text-left"
  },
  {
    key: "role",
    label: "권한",
    align: "text-left",
    editType: "select",
    options: [
      { value: "USER", label: "일반" },
      { value: "ADMIN", label: "관리자" }
    ]
  },
  {
    key: "is_active",
    label: "사용 여부",
    editType: "bool"
  }
]
